export var convertMilitaryToStandardTime = function (time) {
    var split = time.split(':');
    var normalized = ((+split[0] + 11) % 12) + 1;
    return normalized + ':' + split[1] + "".concat(+split[0] > 12 ? ' PM' : ' AM');
};
